module.exports = __webpack_public_path__ + "static/media/hirings.825d27b5.jpg";